export default "__VITE_ASSET__65a4b619__"